import React, { useState } from "react";
import BookConsultModal from "../BookConsultModal";
import wp1 from "../../assets/roof1.jpg";
import wp2 from "../../assets/roof6.jpg";
import wp3 from "../../assets/roof12.jpg";
import wp4 from "../../assets/roof10.jpg";

const RoofCoating = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="bg-white">

      {/* HERO - SPLIT */}
      <section className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-16 items-center">
        <div>
          <h1 className="text-5xl font-serif font-bold leading-tight">
            Roof Coating That <span className="text-amber-600">Extends Roof Life</span>
          </h1>
          <p className="mt-6 text-gray-600 text-lg">
            Stop leaks, reduce heat and avoid expensive roof replacement.
            Our advanced roof coating protects your roof for years.
          </p>

          <div className="mt-8 flex gap-4">
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-amber-600 text-white px-8 py-3 rounded-lg shadow hover:bg-amber-700"
            >
              Get Free Inspection
            </button>
            <button
              onClick={() => setIsModalOpen(true)}
              className="border px-8 py-3 rounded-lg"
            >
              WhatsApp Expert
            </button>
          </div>
        </div>

        <div className="relative">
          <img src={wp1} className="rounded-3xl shadow-2xl" />
          
        </div>
      </section>

      {/* PROBLEM SECTION */}
<section className="py-28 bg-gradient-to-b from-gray-50 to-white">
  <div className="max-w-6xl mx-auto px-6">
    
    <div className="text-center mb-16">
      <h2 className="text-amber-600 text-4xl md:text-5xl font-serif font-semibold tracking-tight">
        Problems Without Roof Coating
      </h2>
      <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
        Ignoring roof protection can silently damage your home and increase long-term maintenance costs.
      </p>
    </div>

    <div className="grid md:grid-cols-4 gap-10">
      {[
        { title: "Water Leakage", desc: "Seepage during heavy rainfall and monsoon season." },
        { title: "Excess Heat", desc: "Higher indoor temperature and discomfort." },
        { title: "Surface Cracks", desc: "Small cracks turning into structural damage." },
        { title: "High Repair Cost", desc: "Expensive fixes due to delayed protection." }
      ].map((item, i) => (
        <div
          key={i}
          className="
            group relative
            bg-white/80 backdrop-blur-md
            border border-gray-200
            rounded-2xl p-8
            transition-all duration-300
            hover:-translate-y-2
            hover:shadow-xl
          "
        >
          {/* subtle red accent */}
          <div className="
            absolute top-0 left-0 h-full w-1
            bg-gradient-to-b from-amber-400 to-amber-600
            rounded-l-2xl
          " />

          <h3 className="text-lg font-semibold mb-2">
            {item.title}
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            {item.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>


     {/* SOLUTIONS */}
<section className="py-28 bg-[#fafafa]">
  <div className="max-w-7xl mx-auto px-6">
    <h2 className="text-amber-600 text-4xl md:text-5xl font-serif font-semibold text-center mb-16 tracking-tight">
      Roof Coating Services We Offer
    </h2>

    <div className="grid md:grid-cols-3 gap-12">
      {[
        { title: "Terrace Roof Coating", desc: "Long-lasting waterproof protection for concrete roofs." },
        { title: "Metal Roof Coating", desc: "Anti-rust and heat resistant coating for sheds." },
        { title: "Tile Roof Protection", desc: "Prevents leakage and tile surface damage." },
        { title: "Heat Proof Coating", desc: "Reduces indoor temperature significantly." },
        { title: "Waterproof Coating", desc: "Stops seepage and moisture completely." },
        { title: "Crack & Joint Sealing", desc: "Seals micro cracks before they expand." }
      ].map((item, i) => (
        <div
          key={i}
          className="
            group relative
            bg-white
            border border-gray-200
            rounded-2xl
            p-10
            transition-all duration-300
            hover:border-amber-500
            hover:shadow-xl
          "
        >
          {/* Accent Line */}
          <div className="
            absolute top-0 left-0 h-1 w-0
            bg-amber-500
            group-hover:w-full
            transition-all duration-300
          " />

          <h3 className="text-xl font-semibold mb-3">
            {item.title}
          </h3>
          <p className="text-gray-600 leading-relaxed">
            {item.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>
{/* HOW WE WORK */}
<section className="py-28 bg-white">
  <div className="max-w-7xl mx-auto px-6 text-center">
    <h2 className="text-amber-600 text-4xl md:text-5xl font-serif font-semibold mb-16">
      How Our Roof Coating Process Works
    </h2>

    <div className="grid md:grid-cols-4 gap-10">
      {[
        { step: "01", title: "Inspection", desc: "Detailed roof inspection by experts." },
        { step: "02", title: "Surface Cleaning", desc: "Dust, cracks & moisture removal." },
        { step: "03", title: "Coating Application", desc: "High-grade waterproof coating." },
        { step: "04", title: "Final Testing", desc: "Leak and durability testing." }
      ].map((item, i) => (
        <div key={i} className="bg-gray-50 p-8 rounded-2xl shadow hover:shadow-xl transition">
          <div className="text-amber-600 text-3xl font-bold mb-4">{item.step}</div>
          <h3 className="font-semibold mb-2">{item.title}</h3>
          <p className="text-gray-600 text-sm">{item.desc}</p>
        </div>
      ))}
    </div>
  </div>
</section>


<div className="grid md:grid-cols-3 gap-6">
  {[wp4, wp2, wp3].map((img, i) => (
    <img 
      key={i} 
      src={img} 
      className="mx-auto h-72 object-cover rounded-2xl"
    />
  ))}
</div>


      {/* WHY US STATS */}
      <section className="py-24">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-4 text-center gap-8">
          <div>
            <h3 className="text-4xl font-bold text-amber-600">8+</h3>
            <p>Years Experience</p>
          </div>
          <div>
            <h3 className="text-4xl font-bold text-amber-600">1200+</h3>
            <p>Roofs Protected</p>
          </div>
          <div>
            <h3 className="text-4xl font-bold text-amber-600">10 Years</h3>
            <p>Service Warranty</p>
          </div>
          <div>
            <h3 className="text-4xl font-bold text-amber-600">4.9★</h3>
            <p>Customer Rating</p>
          </div>
        </div>
      </section>

      {/* FAQ */}
<section className="py-28 bg-[#fafafa]">
  <div className="max-w-6xl mx-auto px-6">
    <h2 className="text-amber-600 text-4xl md:text-5xl font-serif font-semibold text-center mb-16">
      Frequently Asked Questions
    </h2>

    <div className="space-y-6">
      {[
        { q: "How long does roof coating last?", a: "Typically 8–10 years depending on exposure." },
        { q: "Is roof coating better than replacement?", a: "Yes, it's 70% cheaper and faster." },
        { q: "Can it be applied in monsoon?", a: "Best applied in dry conditions." },
        { q: "Does it reduce heat?", a: "Yes, indoor temperature reduces by 5–7°C." }
      ].map((item, i) => (
        <div key={i} className="bg-white p-6 rounded-xl shadow">
          <h3 className="font-semibold mb-2">{item.q}</h3>
          <p className="text-gray-600 text-sm">{item.a}</p>
        </div>
      ))}
    </div>
  </div>
</section>

{/* FINAL CTA */}
<section className="py-32 bg-[#fafafa]">
  <div className="max-w-6xl mx-auto px-6">
    
    <div className="
      relative
      bg-white
      rounded-3xl
      border border-gray-200
      p-16
      text-center
      shadow-[0_20px_60px_rgba(0,0,0,0.08)]
    ">
      
      {/* thin accent */}
      <div className="absolute top-0 left-0 w-full h-[3px] bg-amber-500 rounded-t-3xl" />

      <h2 className="text-4xl md:text-5xl font-semibold tracking-tight mb-4">
        Ready to Protect Your Roof?
      </h2>
      <p className="text-gray-600 text-lg max-w-2xl mx-auto mb-10">
        Get a free professional roof inspection and personalised coating recommendation.
      </p>

      <button
        onClick={() => setIsModalOpen(true)}
        className="
          inline-flex items-center
          px-12 py-4
          rounded-full
          bg-amber-600 text-white
          font-medium
          shadow-lg
          transition-all duration-300
          hover:scale-105 hover:shadow-xl
        "
      >
        Book Free Inspection
      </button>

      <p className="mt-6 text-sm text-gray-400">
        No spam. No obligation. Just expert advice.
      </p>
    </div>

  </div>
</section>


      <BookConsultModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default RoofCoating;
